import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const TwitchSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      height="33"
      viewBox="0 -7 12 28"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        fill={color}
        d="m3.00558.427734-2.857142 2.857146v10.28572h3.428572v2.8571l2.85714-2.8571h2.28572l5.14283-5.14287v-7.999996zm9.71432 7.428576-2.2857 2.28569h-2.28576l-2 2v-2h-2.57143v-8.57141h9.14289z"
      />
      <Path fill={color} d="m11.0056 3.57059h-1.14288v3.42857h1.14288z" />
      <Path fill={color} d="m7.86272 3.57059h-1.14285v3.42857h1.14285z" />
    </Svg>
  )
}

export default TwitchSvg
